// module.exports = `https://sport.sun8tv.com`;
module.exports = `https://test3_pc.sun8tv.com`;
// module.exports = `https://test2_api.sun8tv.com`;
// module.exports = `https://api.zhou618.com`;

